import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import PurchaseOrderList from '../../components/Purchase/PurchaseOrderList';
const PurchaseOrderListPage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <PurchaseOrderList/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};
export default PurchaseOrderListPage;